import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import _ from "lodash";
import uuid from "react-uuid";
import Loading from "../../../common/components/loading/loading";
import { getMarketGroups } from "../../../common/services/markets/marketGroupService";
import SearchBox from "../../../common/components/search/searchBox";
import MarketGroupsTable from "./marketGroupsTable";
import { withTranslation } from "react-i18next";

class MarketGroups extends Component {
  constructor(props) {
    super(props);

    this.handleMarketGroupUpdated = this.handleMarketGroupUpdated.bind(this);
  }

  state = {
    marketGroups: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "name", order: "asc" },
    isLoading: true,
    paginationState: {
      currentPage: 0,
      pageSize: 20,
    },
  };

  async componentDidMount() {
    this.setState({ marketGroups: await getMarketGroups(), isLoading: false });
  }

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      paginationState: {
        ...this.state.paginationState,
        currentPage: 0,
      },
    });
  };

  handleSort = (colId, sort) => {
    if (colId && sort) {
      this.setState({
        sortColumn: {
          path: colId,
          order: sort,
        },
      });
    }
  };

  handleToggleActiveOnly = () => {
    this.setState({
      activeOnly: !this.state.activeOnly,
      paginationState: {
        ...this.state.paginationState,
        currentPage: 0,
      },
    });
  };

  handleMarketGroupSelected = (marketGroup, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(marketGroup, this.handleMarketGroupUpdated, isNew);
  };

  handleMarketGroupUpdated = (marketGroup) => {
    const marketGroups = [...this.state.marketGroups];
    const index = marketGroups.findIndex(
      (u) => u.marketGroupId === marketGroup.marketGroupId
    );
    if (index > -1) {
      marketGroups.splice(index, 1);
    }
    marketGroups.push(marketGroup);
    this.setState({ marketGroups: marketGroups });
  };

  handlePaginationChanged = (params) => {
    if (params && params.api) {
      this.setState({
        paginationState: {
          currentPage: params.api.paginationGetCurrentPage(),
          pageSize: params.api.paginationGetPageSize(),
        },
      });
    }
  };

  getFilteredData = () => {
    const {
      sortColumn,
      searchQuery,
      marketGroups: allMarketGroups,
      activeOnly,
    } = this.state;

    let filtered = allMarketGroups;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          u.name != null &&
          u.name.toLowerCase().includes(searchQuery.toLowerCase())
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: filtered.length, data: sorted };
  };

  render() {
    const { searchQuery, activeOnly, isLoading, paginationState } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const { totalCount, data: marketGroups } = this.getFilteredData();

    const newMarketGroup = {
      marketGroupId: uuid(),
      name: t("NewMarketGroup"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() =>
                  this.handleMarketGroupSelected(newMarketGroup, true)
                }
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddMarketGroup")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedMarketGroup", { count: totalCount })}</p>
        <MarketGroupsTable
          marketGroups={marketGroups}
          onSort={this.handleSort}
          onRowClick={this.handleMarketGroupSelected}
          onPaginationChanged={this.handlePaginationChanged}
          paginationState={paginationState}
        />
      </div>
    );
  }
}

export default withTranslation(["markets"])(MarketGroups);
